export default __webpack_public_path__ + "static/media/dt_metropolis.b0244c7e.mp3";